module.exports = __webpack_public_path__ + "img/main_logo.e85a0199.png";